import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

const deleteMonitoringPage = async (id: string): Promise<void> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId) return
  await analyticsApi().delete(`/v1_private/ads-library/monitoring-pages/${id}`)
}

export const useDeleteMonitoringPageMutation = (options?: {
  onError?: (error: unknown) => void
  onSuccess?: () => void
}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteMonitoringPage,
    onError: options?.onError,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_MONITORING_PAGES],
      })
      options?.onSuccess?.()
    },
  })
}
